import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Layout from './components/Layout';
import SettingsPage from './pages/Settings';
import OfferPage from './pages/Offer';
import CreateDocument from './pages/CreateDocumentPage';
import EditDocumentPage from './pages/EditDocumentPage';
import DocumentDetails from './pages/DocumentDetails';
import InvoicePage from './pages/InvoicePage';
import InfoPage from './pages/InfoPage';
import InvoiceBookPage from './pages/InvoiceBookPage';
import usePageTracking from './hooks/usePageTracking';
import PageTrackingWrapper from './components/shared/PageTrackingWrapper';


const App: React.FC = () => {
  return (
    <Router>
      <PageTrackingWrapper />
      <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/invoice-book" element={<InvoiceBookPage />} />
        <Route path="/offers" element={<OfferPage />} />
        <Route path="/invoices" element={<InvoicePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/account" element={<SettingsPage />} />
        <Route path="/settings/billing" element={<SettingsPage />} />
        <Route path="/settings/notification" element={<SettingsPage />} />
        <Route path="/settings/invoice" element={<SettingsPage />} />
        <Route path="/detail/:id" element={<DocumentDetails/>} />
        <Route path="/edit/:id" element={<EditDocumentPage />} />
        <Route path="/create" element={<CreateDocument/>} />
      </Routes>
      </Layout>      
    </Router>
  )
}

export default App;
